var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { parseAPIUser } from "../api-parsers/parseAPIUser";
import { generateHeaders } from "../helpers/generateHeaders";
export var createUser = function (bnAPIUrl, accessToken, user) { return __awaiter(void 0, void 0, void 0, function () {
    var res, createdUser, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "PUT",
                        url: bnAPIUrl + "/admin/user",
                        headers: generateHeaders(accessToken),
                        data: user,
                    })];
            case 1:
                res = _a.sent();
                createdUser = parseAPIUser(res.data.user);
                return [2, createdUser];
            case 2:
                error_1 = _a.sent();
                console.error(error_1);
                throw error_1;
            case 3: return [2];
        }
    });
}); };
export var updateUser = function (bnAPIUrl, accessToken, user, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var res, updatedUser, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "POST",
                        url: bnAPIUrl + "/admin/user/" + userId,
                        headers: generateHeaders(accessToken),
                        data: __assign({}, user),
                    })];
            case 1:
                res = _a.sent();
                updatedUser = parseAPIUser(res.data.user);
                return [2, updatedUser];
            case 2:
                error_2 = _a.sent();
                console.error(error_2);
                throw error_2;
            case 3: return [2];
        }
    });
}); };
export var deleteUser = function (bnAPIUrl, accessToken, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var res, user, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "DELETE",
                        url: bnAPIUrl + "/admin/user/" + userId,
                        headers: generateHeaders(accessToken),
                    })];
            case 1:
                res = _a.sent();
                user = parseAPIUser(res.data.user);
                return [2, user];
            case 2:
                error_3 = _a.sent();
                console.error(error_3);
                throw error_3;
            case 3: return [2];
        }
    });
}); };
export var listUser = function (bnAPIUrl, accessToken, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var res, user, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "GET",
                        url: bnAPIUrl + "/admin/user/" + userId,
                        headers: generateHeaders(accessToken),
                    })];
            case 1:
                res = _a.sent();
                user = parseAPIUser(res.data.user);
                return [2, user];
            case 2:
                error_4 = _a.sent();
                console.error(error_4);
                throw error_4;
            case 3: return [2];
        }
    });
}); };
export var listUsers = function (bnAPIUrl, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var res, users, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "GET",
                        url: bnAPIUrl + "/admin/users",
                        headers: generateHeaders(accessToken),
                    })];
            case 1:
                res = _a.sent();
                users = res.data.users.map(function (u) { return parseAPIUser(u); });
                return [2, users];
            case 2:
                error_5 = _a.sent();
                console.error(error_5);
                throw error_5;
            case 3: return [2];
        }
    });
}); };
export var userProfile = function (bnAPIUrl, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var res, user, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "GET",
                        url: bnAPIUrl + "/user/profile",
                        headers: generateHeaders(accessToken),
                    })];
            case 1:
                res = _a.sent();
                user = parseAPIUser(res.data.user);
                return [2, user];
            case 2:
                error_6 = _a.sent();
                console.error(error_6);
                throw error_6;
            case 3: return [2];
        }
    });
}); };
export var updateUserProfile = function (bnAPIUrl, accessToken, user) { return __awaiter(void 0, void 0, void 0, function () {
    var res, updatedUser, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "PUT",
                        url: bnAPIUrl + "/user/profile",
                        headers: generateHeaders(accessToken),
                        data: __assign({}, user),
                    })];
            case 1:
                res = _a.sent();
                updatedUser = parseAPIUser(res.data.user);
                return [2, updatedUser];
            case 2:
                error_7 = _a.sent();
                console.error(error_7);
                throw error_7;
            case 3: return [2];
        }
    });
}); };
//# sourceMappingURL=userManagement.js.map